import { render, staticRenderFns } from "./AppWorkAnalyzerTransportTable.vue?vue&type=template&id=38f2ff69&scoped=true&"
import script from "./AppWorkAnalyzerTransportTable.vue?vue&type=script&lang=js&"
export * from "./AppWorkAnalyzerTransportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2ff69",
  null
  
)

export default component.exports